import React from 'react';
import { API } from 'aws-amplify';
import moment from 'moment-timezone';
import { useConfirm } from 'material-ui-confirm';
import useSnack from 'hooks/useSnack';
import { useMutation } from 'react-apollo';
import { CANCEL_MILESTONE_MEETING } from 'graphql/student/milestones';
import PRODUCTS from 'constant/product-types';
import { ADD_CREDIT } from 'graphql/credits';
import { toUserTimezone } from 'utils';

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

export default function useMeeting(student) {
  const snack = useSnack();
  const confirm = useConfirm();
  const [updateTask] = useMutation(CANCEL_MILESTONE_MEETING);
  const [updateCredit] = useMutation(ADD_CREDIT);
  const cancelMeeting = (task, useCredit) => {
    return API.del('api', `/calendar/events/${task.response.eventId}`).then(
      () => {
        snack.success('Meeting canceled.');
        const payload = {
          id: task.id,
          
        };
        if (useCredit) {
          payload.input = {
            status: 'done',
            completed_at: toUserTimezone(new Date()),
            response: {
              ...task.response,
              canceled: true,
              use_credit: true,
            },
          };
        } else {
          payload.input = {
            due_date: null,
            status: null,
            response: null,
          };
        }
        return updateTask({
          variables: payload,
        }).then(() => {
          if (useCredit) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            updateCredit({
              variables: {
                input: {
                  credit_type: task.exercise.meeting_type,
                  user_id: task.user_id,
                  amount: -1,
                  description: 'Credit usage',
                },
              },
            });
          }
          window.analytics.track('Meeting Canceled', {
            ...task,
            product: PRODUCTS_LOOKUP[student.product_type],
          });
        });
      },
      (e) => snack.error(e.message),
    );
  };

  const onCancelMeeting = (task) => {
    if (task.response?.eventId) {
      const now = moment.utc();
      const dueInHour = moment(task.due_date).diff(now, 'h', true);
      /**
       * If canceled in less than 24 hours then the meting is deemed done.
       */
      if (dueInHour < 24) {
        return confirm({
          title: 'Warning!',
          confirmationText: 'Cancel Session',
          cancellationText: 'Go Back',
          description:
            'Are you sure? Canceling a session less than 24 hours before the meeting time counts as a meeting credit.',
        }).then(() => cancelMeeting(task, true));
      } else {
        return confirm({
          confirmationText: 'Cancel Session',
          cancellationText: 'Go Back',
          description:
            'Canceling a session cannot be undone and may result in your reserved timeslot being unavailable in the future.',
        }).then(() => cancelMeeting(task));
      }
    } else {
      snack.info('This meeting cannot be canceled.');
    }
  };

  return {
    onCancelMeeting,
  };
}
